import React from 'react';
import styled from 'styled-components';
import { AppHeader } from './AppHeader';
import { PricingInsightsTransitionBanner } from './PricingInsightsTransitionBanner';
import { isUserFromSTMS } from './pages/carrier-pay/unlock/UnlockUtils';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const Container = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  padding: 24px;
`;

interface Props {
  children: React.ReactNode;
}

export function AppLayout({ children }: Props) {
  return (
    <Wrapper>
      {isUserFromSTMS() && <PricingInsightsTransitionBanner />}
      <AppHeader />

      <Container>{children}</Container>
    </Wrapper>
  );
}
